import React from 'react'
import styles from './styles.module.scss'

const Overlay = React.memo(({onClick}) => <div className={styles.overlay} onClick={onClick} />)

export default Overlay